import React, { FC } from 'react';
import { Moment } from 'moment';

import { useLang } from 'hooks';
import { useProfileBalanceQuery, useStatisticsVolumesQuery } from 'hooks/queries';

import CardView from './CardView';

type BalanceCardProps = {
  dateFrom: Moment;
  dateTo: Moment;
};

const BalanceCard: FC<BalanceCardProps> = ({ dateFrom, dateTo }) => {
  const lang = useLang();

  const balanceQuery = useProfileBalanceQuery();
  const volumesQuery = useStatisticsVolumesQuery({ dateFrom, dateTo });

  return (
    <CardView
      title={lang.get('dashboard.card.balance')}
      amounts={volumesQuery.data?.map((volume) => ({
        date: volume.day,
        value: volume.balance,
      })) ?? []}
      amount={balanceQuery.data?.balance ?? 0}
      loading={balanceQuery.isLoading || volumesQuery.isLoading}
      primary
    />
  );
};

export default BalanceCard;
